<template>
  <b-nav class="signin-nav">
    <li class="nav-item">
      <router-link
        to="/account/signin"
        active-class="signin-nav__link--active"
        class="nav-link signin-nav__link"
        data-testid="account-signin"
      >
        {{ $t('signin.account.tab') }}
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        to="/enterprise/signin"
        active-class="signin-nav__link--active"
        class="nav-link signin-nav__link"
        data-testid="enterprise-signin"
      >
        {{ $t('signin.enterprise.tab') }}
      </router-link>
    </li>
  </b-nav>
</template>

<script>
import { BNav } from '@ui/components'

export default {
  components: {
    BNav
  }
}
</script>

<style lang="scss" scoped>
@import "~@ui/styles/src/scss/utils/lib";

.signin-nav {
  :deep(.nav-item) {
    margin: 0 1.3rem 0 1.3rem;
  }

  :deep(.signin-nav__link) {
    color: $grey-60;
    border: none;
    border-bottom: 5px solid transparent;

    &:hover {
      color: white;
    }
  }

  :deep(.signin-nav__link--active) {
    color: white;
    background-color: transparent;
    border-bottom-color: $primaryColor;
  }
}
</style>
